export default __webpack_public_path__ + "static/media/estufa.2b929085.png";